module.exports = __webpack_public_path__ + "img/2-male-plumber-and-female-customer-in-the-kitchen-EKTSSW7.a4f82628.jpg";